import React from 'react';
import { CircularProgress } from '@mui/material';

function Loader() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <CircularProgress color="inherit" />
      Loading...
    </div>
  );
}

export default Loader;
